module.exports = __webpack_public_path__ + "img/chamadas-publicas.1530b167.png";